import { CollapsibleItem, CollapsiblePositionBaseValue } from '@addins/core/singlecallcard';

export class DepartureTicketInfoCollapsibleItem extends CollapsibleItem {
  constructor() {
    super('Mobile.TechnicalData', 'DepartureTicketInfo/CallcardDepartureTicketInfo', CollapsiblePositionBaseValue.DepartureTicketInfo);
  }
}
